<div class="indexer-container">
  <form [formGroup]="indexerForm">
    @for (field of indexerFields; track field) {
      <div class="field-container">
        @if (!field.multiValue) {
          <app-field
            [field]="field"
            [form-control]="getFormControl(field.id)"
            (fieldFocused)="onFieldFocus($event)"
            (fieldBlurred)="onFieldBlur($event)"
          ></app-field>
        }
        @if (field.multiValue) {
          <app-multi-value-field
            [field]="field"
            [form]="getMultiValueFormArray(field.id)"
            (fieldFocused)="onFieldFocus($event)"
            (fieldBlurred)="onFieldBlur($event)"
            (multiValueEntryRemoved)="onMultiValueEntryRemoved($event)"
          ></app-multi-value-field>
        }
        @if (
          !field.multiValue && getAdvancedLinksForField(field.id);
          as advancedLinks
        ) {
          @if (advancedLinks.length > 0) {
            <button
              mat-mini-fab
              mat-small-icon-button
              type="button"
              class="advanced-link-button"
              [matTooltip]="'OPEN_ADVANCED_LINKS' | transloco"
              (click)="onClickAdvancedLink(advancedLinks)"
            >
              <mat-icon>link</mat-icon>
            </button>
          }
        }
      </div>
    }
  </form>
  @for (tableField of tableFields; track tableField) {
    <app-table-field-button
      [table-field]="tableField"
      [document-id]="id"
      [document-secure-id]="secureId"
    ></app-table-field-button>
  }
</div>
